import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { SitesRouteNames, SitesRoutePathNames } from '../../../../enums';

const Component = () => import('./RecommendationDetails.vue');

export default {
  path: buildChildURL(SitesRoutePathNames.RECOMMENDATION_DETAILS),
  name: SitesRouteNames.SITE_RECOMMENDATION_DETAILS,
  component: Component,
} as RouteRecordRaw;
